import DateFilter from '@/components/date-filter';
import ManageActionCreanceAssurance from '@/components/comptable/creance/manage-action-creance-assurance'
import store_operation from "@/store/mods/caisse/operations"
import $ from 'jquery'

export default {
    name: 'creance-assurance',
    components: {
        DateFilter, ManageActionCreanceAssurance
    },
    props: {
        user_info: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            is_month: false,
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            liste_creances_assurance: [],

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            fields: [
                { key: 'no', label: 'N°' },
                { key: 'assurance', label: 'Assurance | Société' },
                { key: 'part_assureur', label: 'Part assureur', class: 'text-right' },
                { key: 'etat', label: 'État' },
                { key: 'action', label: 'Actions' }
            ],

            search_filter: "",
            perPage: 25,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,

            is_loading: true,
            is_empty: false,
            is_load_error: false,
            selected_facture: {},
            action_toggler: 0,
            detail_toggler: 0,

            liste_assurances: [],
            liste_societes: [],
            seleted_assurance: null,
            selected_societe: '',
            selected_facture_detail: [],
            is_assurance_bill: true
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date && this.filter_date.slug) {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.operations_tobe_canceled = []
            const data = {
                is_creance: 1,
                month: this.curr_month ? this.curr_month.id : "",
                libelle_month: this.curr_month ? this.curr_month.lib : "",
                one_date: "",
                from_date: "",
                to_date: "",
                user_id: this.personnel_id
            }
            this.current_date_filter = data
            this.is_month = !!this.curr_month
            this.fetchCreancesAssurance()
        },

        seleted_assurance() {
            this.is_assurance_bill = true
            this.selected_societe = ''
            this.fetchSocieteByAssurance()

            this.current_date_filter.assurance_id = (this.seleted_assurance && this.seleted_assurance.id > 0)?this.seleted_assurance.id:null
            this.fetchCreancesAssurance()
        },

        selected_societe() {
            this.current_date_filter.souscripteur_id = (this.selected_societe != null)?this.selected_societe?.id:''
            if (this.current_date_filter.souscripteur_id > 0) {
                this.is_assurance_bill = false
            } else if (this.current_date_filter.souscripteur_id === 0) {
                this.is_assurance_bill = true
            }
            this.fetchCreancesAssurance()
        },
    },

    computed: {
        assurances() {
            return this.$store.getters["assurances"];
        },

        souscripteurs() {
            return this.$store.getters["souscripteurs"];
        },
    },

    mounted() {
        this.fetchListAssurances() 

        const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
        }
        this.current_date_filter = data
        this.fetchCreancesAssurance()
    },

    methods: {
        fetchListAssurances() {
            this.liste_assurances = []
            this.$store.dispatch("getAssurances").then(() => {
                const tmp_assur = {
                    id: 0,
                    raison_sociale: "Toutes les assurances"
                }
                this.liste_assurances = [tmp_assur, ...this.assurances]
            })
        },

        fetchSocieteByAssurance() {
            if (this.seleted_assurance == null) {
                this.liste_societes =  []
                return;
            }

            const assurance_id = this.seleted_assurance.id

            if (assurance_id > 0) {
                this.$store.dispatch("getSocieteByAssurance", assurance_id).then(() => {
                    const tmp_societe = {
                        id: 0,
                        souscripteur: "Toutes les sociétés"
                    }
                    this.liste_societes = [tmp_societe, ...this.souscripteurs]
                })
            } else {
                this.liste_societes =  []
            }
        },

        fetchCreancesAssurance() {
            this.is_loading = true
            this.liste_creances_assurance = []
            store_operation.getCreanceAssurance(this.current_date_filter).then((response) => {
                this.liste_creances_assurance = response.data
                this.total_pages = response.last_page
                if (this.liste_creances_assurance.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_load_error = true
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.fetchCreancesAssurance()
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.current_date_filter.page = this.currentPage
                this.fetchCreancesAssurance()
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.current_date_filter.page = this.currentPage
                this.fetchCreancesAssurance()
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.current_date_filter.page = this.currentPage
                this.fetchCreancesAssurance()
            }
        },

        async arreterFacture(data) {
            this.selected_facture_detail = []
            this.action_toggler = (this.action_toggler == 0)?1:0
            this.selected_facture = data
            
            this.current_date_filter.assurance_id = data.assurance_id
            await store_operation.getDetailFactureAssuranceSociete(this.current_date_filter).then((response) => {
                this.selected_facture_detail = response
                setTimeout(() => {
                    $('.arret-creance').modal('show')
                }, 100);
            })
        },

        deposerFacture(data) {
            this.action_toggler = (this.action_toggler == 0)?1:0
            this.selected_facture = data
            setTimeout(() => {
                $('.depot-creance').modal('show')
            }, 100);
        },

        relancerFacture(data) {
            this.action_toggler = (this.action_toggler == 0)?1:0
            this.selected_facture = data
            setTimeout(() => {
                $('.relance-creance').modal('show')
            }, 100);
        },

        historiqueFacture(data) {
            this.action_toggler = (this.action_toggler == 0)?1:0
            this.selected_facture = data
            setTimeout(() => {
                $('.historique-creance').modal('show')
            }, 100);
        },

        gotToFactureEncours() {
            console.log("Toggle the view");
            
            this.$emit('emitToggleView')  
        },

        async showDetailFactureAssurance(data) {
            this.selected_facture = data
            this.current_date_filter.assurance_id = data.assurance_id
            await store_operation.getDetailFactureAssuranceSociete(this.current_date_filter).then((response) => {
                this.selected_facture_detail = response
                this.detail_toggler = (this.detail_toggler == 0)?1:0
                setTimeout(() => {
                    $('.show-detail-bill').modal('show')
                }, 100);
            })
        }
    }
}
